import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.slice.js";
import Vue from 'vue';
Vue.filter('date', function (value) {
  var fullDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  value = String(value);
  var date = value.slice(8, 10).trim();
  var month = value.slice(4, 7).trim();
  var year = value.slice(11, 15);
  if (!fullDate) return date + ' ' + month;else return date + ' ' + month + ' ' + year;
});